import { render, staticRenderFns } from "./assignment-request-review.vue?vue&type=template&id=5f937492&scoped=true"
import script from "./assignment-request-review.vue?vue&type=script&lang=js"
export * from "./assignment-request-review.vue?vue&type=script&lang=js"
import style0 from "./assignment-request-review.vue?vue&type=style&index=0&id=5f937492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f937492",
  null
  
)

export default component.exports